import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import URLS from "@api/constants/urls";
import { urlUtility } from "@repo/utilities/url.utility.ts";

export const useGetAllReportsService = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const reportId = urlQueries["report-id"];
  const allReportService = useQuery({
    queryKey: [...CACHE_KEYS.REPORTS, page, debouncedQuery, per_page],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.REPORTS,
        searchParams: {
          page,
          per_page,
          "filter[name]": debouncedQuery,
        },
      }),
    enabled: enableQuery,
  });

  const singleReportService = useQuery({
    queryKey: [...CACHE_KEYS.REPORTS, reportId],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: `${URLS.REPORTS}/${reportId}`,
      }),
    enabled: reportId ? true : false,
  });

  return {
    services: { allReportService, singleReportService },
    states: { searchQuery, setSearchQuery },
  };
};
